<div class="find-account-container">
  <div class="find-account-card">
    <div class="logo-header">
      <img [src]="logoPath" alt="Nevada Department of Education Logo" class="nevada-logo">
    </div>

    <div class="horizontal-line"></div>

    <div class="content-section">
      <div class="header-content">
        <h1>Find Your Account</h1>
        <p class="subtitle">
          Enter the email address associated with your account. We’ll send a one-time verification code to this email.
        </p>
      </div>

      <form [formGroup]="findAccountForm" (ngSubmit)="onSubmit()">
        <div class="text-field">
          <div class="label-container">
            <label for="email" class="label">Email</label>
          </div>
          <div class="input-container">
            <input type="email" id="email" formControlName="email" placeholder="Enter Email"
              [ngClass]="{'is-invalid': isSubmitted && formControls['email'].errors}" maxlength="255">
            <div *ngIf="(isSubmitted || formControls['email'].touched) && formControls['email'].errors"
              class="error-message1">
              <span *ngIf="formControls['email'].errors?.['required']">Please enter your email address.</span>
              <span *ngIf="formControls['email'].errors?.['email'] || formControls['email'].errors?.['pattern']">Please
                enter a valid email address.</span>
            </div>
          </div>
        </div>

        <div class="action-buttons">
          <button class="cstmBtn cancel-btn" (click)="cancel()" id="btn_forgot-password-email_cancel">Cancel</button>
          <button type="submit" class="cstmBtn cta-button" id="btn_forgot-password-email_submit"
            [disabled]="isButtonDisabled">
            <span class="button-text">Send Code</span>
          </button>

          <!-- <div class="action-buttons">
            <button type="submit" class="cta-button" id="btn_forgot-password-email_submit" [disabled]="isButtonDisabled"
              (click)="getToastMessage()">
            <span class="button-text">Send Code</span>
            </button>
            <button class="cancel-btn" id="btn_forgot-password-email_cancel" (click)="cancel()">Cancel</button>
          </div> -->
          </div>          
      </form>
    </div>

  </div>

  <div class="toast-message" *ngIf="showToastDiv" id="toast_message" [ngClass]="{
    'toast-message-success' : toastType === true,
    'toast-message-failed' : toastType === false}">
    <div class="success-icon">
      <img
        [src]="toastType === true ? 'assets/images/cardy-ai/tick icon.png' : 'assets/images/cardy-ai/window-close-icon-white.svg' "
        alt="toastIcon">
    </div>
    <p>{{toastMessage}}</p>
  </div>
</div>